import script from "./envideo.vue?vue&type=script&setup=true&lang=js"
export * from "./envideo.vue?vue&type=script&setup=true&lang=js"

import "./envideo.vue?vue&type=style&index=0&id=87a2d588&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87a2d588"]])

export default __exports__